<template>
  <div class="page__data_center b-page" style="padding-top: 10px; min-height: 100vh">
    <div id="select-block" style="background-color:white; padding:10px 10px; overflow: hidden;">
      <div style="padding-left: 5px">
        <p class="text-primary" style="font-weight: bold; font-size: 20px">{{ $t('menu.monthly_reporting') }}</p>
      </div>

      <el-row style="margin-top: 20px; padding-left: 5px">
        <el-col :sm="18">
          <div style="display: inline-block; margin-right: 10px">
            <shop-select v-model="shopee_shop.selected" :shopee_shop_list="shopee_shop.list"
                         :disabled="loading.get_data"></shop-select>
          </div>
          <div style="display: inline-block">
            <el-date-picker
              id="date-picker-data-center"
              v-model="date_range"
              type="monthrange"
              format="MM-yyyy"
              :picker-options="{firstDayOfWeek: 1, disabledDate(time) {return time.getTime() > Date.now()}}"
              :placeholder="$t('input.select_time')"
              :start-placeholder="$t('input.start_month')"
              :end-placeholder="$t('input.end_month')"
              size="small"
              :disabled="!shopee_shop.selected || loading.get_data">
            </el-date-picker>
          </div>
        </el-col>
        <el-col :sm="6" class="text-right" style="padding-right: 5px">
          <el-button size="small" type="primary" icon="el-icon-check" @click="m__update_data()"
                     :loading="loading.get_data" :disabled="!shopee_shop.selected">
            {{ $t('base.analyze_data') }}
          </el-button>
        </el-col>
      </el-row>
    </div>

    <div
      style="background-color:white; padding: 5px 10px 10px 10px; overflow: hidden; margin-top: 10px">
      <div style="margin-top: 50px">
        <div style="display: flex; justify-content: space-between;">
          <strong style="font-size: 14px">{{ $t('center.shop_overview_report') }}</strong>
          <el-button size="mini" icon="el-icon-download" :disabled="!shopee_shop.selected || loading.get_data"
                     @click="m__export_data(1)">
            {{ $t('base.export_data') }}
          </el-button>
        </div>
        <el-table ref="data1" :data="data1" style="margin-top: 20px">
          <el-table-column min-width="150px" :label="$t('base.month')" prop="label">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini"
                           @click="m__show_data1_detail_dialog(scope.row.label, scope.row.detail)">
                  <strong class="text-primary">
                    {{ scope.row.label }}
                  </strong>
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="150px" label="GMV" prop="gmv" sortable>
            <template slot-scope="scope">
              {{ scope.row.gmv | currency }}
            </template>
          </el-table-column>
          <el-table-column min-width="150px" :label="$t('metric.orders')" prop="order" sortable>
            <template slot-scope="scope">
              {{ scope.row.order | currency }}
            </template>
          </el-table-column>
          <el-table-column min-width="150px" label="AOV" prop="aov" sortable>
            <template slot-scope="scope">
              {{ scope.row.aov | currency }}
            </template>
          </el-table-column>
          <el-table-column min-width="150px" label="GMV Ads" prop="gmv_ads" sortable>
            <template slot-scope="scope">
              {{ scope.row.gmv_ads | currency }}
            </template>
          </el-table-column>
          <el-table-column min-width="150px" :label="$t('metric.ads_expense')" prop="cost_ads" sortable>
            <template slot-scope="scope">
              {{ scope.row.cost_ads | currency }}
            </template>
          </el-table-column>
          <el-table-column min-width="150px" :label="$t('metric.ads_orders')" prop="order_ads" sortable>
            <template slot-scope="scope">
              {{ scope.row.order_ads | currency }}
            </template>
          </el-table-column>
          <el-table-column min-width="150px" label="AOV Ads" prop="aov_ads" sortable>
            <template slot-scope="scope">
              {{ scope.row.aov_ads | currency }}
            </template>
          </el-table-column>
          <el-table-column min-width="150px" :label="$t('metric.impressions')" prop="view_ads" sortable>
            <template slot-scope="scope">
              {{ scope.row.view_ads | currency }}
            </template>
          </el-table-column>
          <el-table-column min-width="150px" :label="$t('metric.clicks')" prop="click_ads" sortable>
            <template slot-scope="scope">
              {{ scope.row.click_ads | currency }}
            </template>
          </el-table-column>
          <el-table-column min-width="150px" label="CR %" prop="cr" sortable>
            <template slot-scope="scope">
              {{ scope.row.cr }}%
            </template>
          </el-table-column>
          <el-table-column min-width="150px" label="CTR %" prop="ctr" sortable>
            <template slot-scope="scope">
              {{ scope.row.ctr }}%
            </template>
          </el-table-column>
          <el-table-column min-width="150px" label="CIR %" prop="cir" sortable>
            <template slot-scope="scope">
              {{ scope.row.cir }}%
            </template>
          </el-table-column>
          <el-table-column min-width="150px" label="ROAS" prop="roas" sortable>
            <template slot-scope="scope">
              {{ scope.row.roas }}
            </template>
          </el-table-column>
          <el-table-column min-width="150px" label="GMV voucher" prop="gmv_voucher" sortable>
            <template slot-scope="scope">
              {{ scope.row.gmv_voucher | currency }}
            </template>
          </el-table-column>
          <el-table-column min-width="150px" :label="$t('metric.voucher_expense')" prop="cost_voucher" sortable>
            <template slot-scope="scope">
              {{ scope.row.cost_voucher | currency }}
            </template>
          </el-table-column>
          <el-table-column min-width="140px" :label="$t('metric.voucher_usage')" prop="voucher_usage" sortable>
            <template slot-scope="scope">
              {{ scope.row.voucher_usage | currency }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div style="margin-top: 60px">
        <div style="display: flex; justify-content: space-between">
          <strong style="font-size: 14px">{{ $t('center.products_overview_report') }}</strong>
          <el-button size="mini" icon="el-icon-download" :disabled="!shopee_shop.selected || loading.get_data"
                     @click="m__export_data(2)">
            {{ $t('base.export_data') }}
          </el-button>
        </div>
        <el-table ref="data2" :data="data2" style="margin-top: 20px">
          <el-table-column min-width="150px" :label="$t('base.month')" prop="label">
            <template slot-scope="scope">
              {{ scope.row.label }}
            </template>
          </el-table-column>
          <el-table-column min-width="150px" :label="$t('center.uv_pv')" prop="uv_x_pv"
                           sortable>
            <template slot-scope="scope">
              {{ scope.row.uv_x_pv }}%
            </template>
          </el-table-column>
          <el-table-column min-width="150px" :label="$t('center.atc_uv_uv')" prop="atc_uv_x_uv" sortable>
            <template slot-scope="scope">
              {{ scope.row.atc_uv_x_uv }}%
            </template>
          </el-table-column>
          <el-table-column min-width="150px" :label="$t('center.placed_buyers_atc_uv')" prop="placed_buyers_x_atc_uv"
                           sortable>
            <template slot-scope="scope">
              {{ scope.row.placed_buyers_x_atc_uv }}%
            </template>
          </el-table-column>
          <el-table-column min-width="150px" :label="$t('center.confirmed_buyers_placed_buyers')"
                           prop="confirmed_buyers_x_placed_buyers" sortable>
            <template slot-scope="scope">
              {{ scope.row.confirmed_buyers_x_placed_buyers }}%
            </template>
          </el-table-column>
          <el-table-column min-width="150px" :label="$t('center.atc_unit_num_atc_uv')" prop="atc_unit_num_x_atc_uv"
                           sortable>
            <template slot-scope="scope">
              {{ scope.row.atc_unit_num_x_atc_uv }}
            </template>
          </el-table-column>
          <el-table-column min-width="150px" :label="$t('center.placed_unit_num_atc_unit_num')"
                           prop="placed_unit_num_x_atc_unit_num" sortable>
            <template slot-scope="scope">
              {{ scope.row.placed_unit_num_x_atc_unit_num }}%
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div style="margin-top: 60px">
        <div style="display: flex">
          <div style="flex: 1">
            <strong style="font-size: 14px">{{ $t('center.product_conversion_report') }}</strong>
          </div>
          <div style="width: 250px; margin-right: 10px">
            <el-input size="mini" v-model="data3_search" suffix-icon="el-icon-search" clearable
                      :placeholder="$t('input.placeholder')"></el-input>
          </div>
          <el-button size="mini" icon="el-icon-download" :disabled="!shopee_shop.selected || loading.get_data"
                     @click="m__export_data(3)">
            {{ $t('base.export_data') }}
          </el-button>
        </div>
        <el-table ref="data3" :data="c__data3_display_list" @sort-change="m__sort_change" style="margin-top: 20px">
          <el-table-column min-width="350px" :label="$t('base.month')" fixed="left">
            <el-table-column min-width="350px" :label="$t('base.product')" show-tooltip-when-overflow prop="name">
              <template slot-scope="scope">
                <div style="display: flex; gap: 10px; align-items: center">
                  <div style="flex: 1; width: 35px; max-width: 35px">
                    <img :src="SHOPEE_IMAGE(scope.row.image)" alt="logo"
                         style="width:35px; height: 35px;">
                  </div>
                  <div style="display: flex; overflow: hidden; text-overflow: ellipsis;">
                    <div>
                      <a href="javascript:void(0)"
                         @click="open_link_fixed(`https://shopee.com/product-i.${shop.shop_id}.${scope.row.itemid}`, shop)">
                        {{ scope.row.name }}
                      </a>
                      <br>
                      <span>
                        {{ $t('product.id') }}: {{ scope.row.itemid }}
                      </span>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column v-for="month in c__get_list_month" :key="month.key" :label="month.label">
            <el-table-column min-width="150px" :label="$t('center.add_to_cart_units_pv')"
                             :prop="`t_${month.key}.add_to_cart_units_x_pv`" sortable="custom">
              <template slot-scope="scope">
                {{ m__get_data3_by_month(scope.row, month.key, 'add_to_cart_units_x_pv') }}%
              </template>
            </el-table-column>
            <el-table-column min-width="130px" :label="$t('center.confirmed_units_add_to_cart_units')"
                             :prop="`t_${month.key}.confirmed_units_x_add_to_cart_units`" sortable="custom">
              <template slot-scope="scope">
                {{ m__get_data3_by_month(scope.row, month.key, 'confirmed_units_x_add_to_cart_units') }}%
              </template>
            </el-table-column>
            <el-table-column min-width="150px" :label="$t('center.sales_confirmed')"
                             :prop="`t_${month.key}.confirmed_sales`" sortable="custom">
              <template slot-scope="scope">
                {{ m__get_data3_by_month(scope.row, month.key, 'confirmed_sales') | currency }}
              </template>
            </el-table-column>
            <template v-if="array_to_set(custom_monthly_report_fixed_list).has($store.state.userInfo.username)">
              <el-table-column min-width="130px" :label="$t('center.placed')"
                               :prop="`t_${month.key}.placed`" sortable="custom">
                <template slot-scope="scope">
                  {{ m__get_data3_by_month(scope.row, month.key, 'placed') | currency }}
                </template>
              </el-table-column>
              <el-table-column min-width="130px" :label="$t('center.placed_sales')"
                               :prop="`t_${month.key}.placed_sales`" sortable="custom">
                <template slot-scope="scope">
                  {{ m__get_data3_by_month(scope.row, month.key, 'placed_sales') | currency }}
                </template>
              </el-table-column>
              <el-table-column min-width="130px" :label="$t('center.canceled')"
                               :prop="`t_${month.key}.canceled`" sortable="custom">
                <template slot-scope="scope">
                  {{ m__get_data3_by_month(scope.row, month.key, 'canceled') | currency }}
                </template>
              </el-table-column>
              <el-table-column min-width="130px" :label="$t('center.canceled_sales')"
                               :prop="`t_${month.key}.canceled_sales`" sortable="custom">
                <template slot-scope="scope">
                  {{ m__get_data3_by_month(scope.row, month.key, 'canceled_sales') | currency }}
                </template>
              </el-table-column>
              <el-table-column min-width="130px" :label="$t('center.to_return')"
                               :prop="`t_${month.key}.to_return`" sortable="custom">
                <template slot-scope="scope">
                  {{ m__get_data3_by_month(scope.row, month.key, 'to_return') | currency }}
                </template>
              </el-table-column>
              <el-table-column min-width="130px" :label="$t('center.to_return_sales')"
                               :prop="`t_${month.key}.to_return_sales`" sortable="custom">
                <template slot-scope="scope">
                  {{ m__get_data3_by_month(scope.row, month.key, 'to_return_sales') | currency }}
                </template>
              </el-table-column>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :current-page.sync="product_filter.current_page" :page-size="product_filter.page_size"
                       layout="prev, pager, next, total" :total="c__data3_filter_list.length"/>
      </div>

      <div style="margin-top: 60px">
        <div style="display: flex">
          <div style="flex: 1">
            <strong style="font-size: 14px">{{ $t('center.flash_sale_report') }}</strong>
          </div>
          <div style="width: 250px; text-align: right">
            <el-button size="mini" icon="el-icon-download" :disabled="!shopee_shop.selected || loading.get_data"
                       @click="m__export_data(5)">
              {{ $t('base.export_data') }}
            </el-button>
          </div>
        </div>
        <el-table ref="data5" :data="data5" @sort-change="m__sort_change" style="margin-top: 20px">
          <el-table-column min-width="150px" :label="$t('base.month')" fixed="left">
            <el-table-column min-width="150px" :label="$t('base.data')" show-tooltip-when-overflow>
              <template slot-scope="scope">
                {{ scope.row.label }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column v-for="month in c__get_list_month" :key="month.key" :label="month.label">
            <template v-for="item in m__get_around_flash_sale(month.value)">
              <el-table-column :label="`${$t('flash_sale.day')} ${item}`" min-width="150px">
                <template slot-scope="scope">
                  {{ m__get_data5_by_month_and_day(scope.row, month.key, item) }}
                </template>
              </el-table-column>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog :visible.sync="show_dialog.see_detail" :close-on-click-modal="false" width="1200px">
      <div slot="title" style="padding:10px">
        <div style="display: flex; justify-content: space-between">
          <div>
            <strong style="font-size:14px">{{ $t('base.data') }}: {{ this.data1_detail.label }}</strong>
          </div>
          <div>
            <el-button size="mini" icon="el-icon-download" :disabled="!shopee_shop.selected || loading.get_data"
                       @click="m__export_data(1.1)">
              {{ $t('base.export_data') }}
            </el-button>
          </div>
        </div>

        <div style="margin-top: 30px;">
          <el-table ref="data1_detail" :data="data1_detail.data" style="margin-top: 20px">
            <el-table-column min-width="150px" :label="$t('flash_sale.day')" prop="label">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.label }}
                </div>
              </template>
            </el-table-column>
            <el-table-column min-width="150px" label="GMV" prop="gmv" sortable>
              <template slot-scope="scope">
                {{ scope.row.gmv | currency }}
              </template>
            </el-table-column>
            <el-table-column min-width="150px" :label="$t('metric.orders')" prop="order" sortable>
              <template slot-scope="scope">
                {{ scope.row.order | currency }}
              </template>
            </el-table-column>
            <el-table-column min-width="150px" label="AOV" prop="aov" sortable>
              <template slot-scope="scope">
                {{ scope.row.aov | currency }}
              </template>
            </el-table-column>
            <el-table-column min-width="150px" label="GMV Ads" prop="gmv_ads" sortable>
              <template slot-scope="scope">
                {{ scope.row.gmv_ads | currency }}
              </template>
            </el-table-column>
            <el-table-column min-width="150px" :label="$t('metric.ads_expense')" prop="cost_ads" sortable>
              <template slot-scope="scope">
                {{ scope.row.cost_ads | currency }}
              </template>
            </el-table-column>
            <el-table-column min-width="150px" :label="$t('metric.ads_orders')" prop="order_ads" sortable>
              <template slot-scope="scope">
                {{ scope.row.order_ads | currency }}
              </template>
            </el-table-column>
            <el-table-column min-width="150px" label="AOV Ads" prop="aov_ads" sortable>
              <template slot-scope="scope">
                {{ scope.row.aov_ads | currency }}
              </template>
            </el-table-column>
            <el-table-column min-width="150px" :label="$t('metric.impressions')" prop="view_ads" sortable>
              <template slot-scope="scope">
                {{ scope.row.view_ads | currency }}
              </template>
            </el-table-column>
            <el-table-column min-width="150px" :label="$t('metric.clicks')" prop="click_ads" sortable>
              <template slot-scope="scope">
                {{ scope.row.click_ads | currency }}
              </template>
            </el-table-column>
            <el-table-column min-width="150px" label="CR %" prop="cr" sortable>
              <template slot-scope="scope">
                {{ scope.row.cr }}%
              </template>
            </el-table-column>
            <el-table-column min-width="150px" label="CTR %" prop="ctr" sortable>
              <template slot-scope="scope">
                {{ scope.row.ctr }}%
              </template>
            </el-table-column>
            <el-table-column min-width="150px" label="CIR %" prop="cir" sortable>
              <template slot-scope="scope">
                {{ scope.row.cir }}%
              </template>
            </el-table-column>
            <el-table-column min-width="150px" label="ROAS" prop="roas" sortable>
              <template slot-scope="scope">
                {{ scope.row.roas }}
              </template>
            </el-table-column>
            <el-table-column min-width="150px" label="GMV voucher" prop="gmv_voucher" sortable>
              <template slot-scope="scope">
                {{ scope.row.gmv_voucher | currency }}
              </template>
            </el-table-column>
            <el-table-column min-width="150px" :label="$t('metric.voucher_expense')" prop="cost_voucher" sortable>
              <template slot-scope="scope">
                {{ scope.row.cost_voucher | currency }}
              </template>
            </el-table-column>
            <el-table-column min-width="140px" :label="$t('metric.voucher_usage')" prop="voucher_usage" sortable>
              <template slot-scope="scope">
                {{ scope.row.voucher_usage | currency }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  take as _take,
  drop as _drop,
  orderBy as _orderBy
} from 'lodash'
import {get_shop_mixins} from "../../mixins/get_shop";
import {fix_ads_mixins} from "../../mixins/fix_ads";
import {custom_monthly_report_fixed_list} from "../../addon/fixed_list";

export default {
  name: 'page__monthly_report',

  mixins: [get_shop_mixins, fix_ads_mixins],

  data() {
    return {
      loading: {
        get_data: false,
        marketing_report_file: false,
        compare_product: false,
        export_report: false
      },
      show_dialog: {
        see_detail: false
      },

      date_range: null,
      seller: null,

      data1: [],
      data2: [],
      data3: [],
      data4: [],
      data5: [],

      data3_search: '',
      product_filter: {
        page_size: 10,
        current_page: 0
      },

      product_sort_option: {
        order: null,
        prop: null
      },

      spike_days: [],

      data1_detail: {
        label: '',
        data: []
      },

      custom_monthly_report_fixed_list
    }
  },

  beforeMount() {
    this.m__get_spike_days()
    this.m__get_shopee_shop()
  },

  watch: {
    'shopee_shop.selected': function () {
      this.m__initial_view()
    }
  },

  computed: {
    c__get_list_month() {
      if (!this.date_range || !this.date_range[0] || !this.date_range[1]) {
        return []
      }

      let start_month = this.dayjs(this.date_range[0]).startOf('month')
      const end_month = this.dayjs(this.date_range[1]).endOf('month')
      const result = []

      while (start_month.isSameOrBefore(end_month, 'month')) {
        result.push({
          label: `Tháng ${start_month.month() + 1}/${start_month.year()}`,
          key: start_month.format('MMYYYY'),
          value: start_month.month() + 1
        })
        start_month = start_month.add(1, 'month')
      }

      return result
    },

    c__data3_filter_list() {
      let result = this.data3

      if (this.product_sort_option.order) {
        this.product_sort_option.order === 'ascending' && (result = _orderBy(result, [this.product_sort_option.prop], ['asc']))
        this.product_sort_option.order === 'descending' && (result = _orderBy(result, [this.product_sort_option.prop], ['desc']))
      }

      const words = this.remove_unicode(this.data3_search)
      return result.filter(item => this.remove_unicode(JSON.stringify({
        itemid: item.itemid,
        name: item.name
      }).normalize()).includes(words))
    },

    c__data3_display_list() {
      const limit = this.product_filter.page_size
      const skip = limit * (this.product_filter.current_page - 1)

      return _take(_drop(this.c__data3_filter_list, skip), limit)
    }
  },

  methods: {
    m__show_data1_detail_dialog(label, data) {
      this.data1_detail.label = label
      this.data1_detail.data = data
      this.show_dialog.see_detail = true
    },

    async m__export_data(name) {
      if (name === 1 && this.data1.length) {
        const column_labels = this.$refs.data1.columns.map(i => i.label)
        const data = []
        for (const row of this.data1) {
          const item = []
          for (const col of this.$refs.data1.columns) {
            item.push(row[col.property])
          }
          data.push(item)
        }

        const filename = `report_${this.shop.username}_${this.dayjs().format('DDMMYYYY')}.xlsx`
        const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/export_excel', {
          filename,
          data: [column_labels, ...data]
        }, {
          ...this.cf(),
          responseType: 'blob'
        })
        const url = window.URL.createObjectURL(new Blob([response.body]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
      }

      if (name === 1.1 && this.data1_detail.data.length) {
        const column_labels = this.$refs.data1_detail.columns.map(i => i.label)
        const data = []
        for (const row of this.data1_detail.data) {
          const item = []
          for (const col of this.$refs.data1_detail.columns) {
            item.push(row[col.property])
          }
          data.push(item)
        }

        const filename = `report_detail_${this.shop.username}_${this.dayjs().format('DDMMYYYY')}.xlsx`
        const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/export_excel', {
          filename,
          data: [column_labels, ...data]
        }, {
          ...this.cf(),
          responseType: 'blob'
        })
        const url = window.URL.createObjectURL(new Blob([response.body]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
      }

      if (name === 2 && this.data2.length) {
        const column_labels = this.$refs.data2.columns.map(i => i.label)
        const data = []
        for (const row of this.data2) {
          const item = []
          for (const col of this.$refs.data2.columns) {
            item.push(row[col.property])
          }
          data.push(item)
        }

        const filename = `report_${this.shop.username}_${this.dayjs().format('DDMMYYYY')}.xlsx`
        const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/export_excel', {
          filename,
          data: [column_labels, ...data]
        }, {
          ...this.cf(),
          responseType: 'blob'
        })
        const url = window.URL.createObjectURL(new Blob([response.body]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
      }

      if (name === 3 && this.data3.length) {
        const row1 = ['', '']
        const row2 = ['Product ID', this.$t('base.product')]
        const data = []

        for (const month of this.c__get_list_month) {
          row1.push(month.label)
          for (let i = 1; i < (this.$refs.data3.columns.length - 1) / this.c__get_list_month.length; i++) {
            row1.push('')
          }
          for (let i = 1; i <= (this.$refs.data3.columns.length - 1) / this.c__get_list_month.length; i++) {
            row2.push(this.$refs.data3.columns[i].label)
          }
        }

        for (const item of this.data3) {
          const row = [item.itemid]
          for (const col of this.$refs.data3.columns) {
            row.push(this.m__get_nested_object(item, col.property))
          }
          data.push(row)
        }

        const filename = `report_${this.shop.username}_${this.dayjs().format('DDMMYYYY')}.xlsx`
        const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/export_excel', {
          filename,
          data: [row1, row2, ...data]
        }, {
          ...this.cf(),
          responseType: 'blob'
        })
        const url = window.URL.createObjectURL(new Blob([response.body]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
      }

      if (name === 5 && this.data5.length) {
        const row1 = [this.$t('base.month')]
        const row2 = [this.$t('base.data')]
        const data = []

        for (const month of this.c__get_list_month) {
          row1.push(month.label)
          for (let i = 1; i < (this.$refs.data5.columns.length - 1) / this.c__get_list_month.length; i++) {
            row1.push('')
          }
          for (let i = 1; i <= (this.$refs.data5.columns.length - 1) / this.c__get_list_month.length; i++) {
            row2.push(this.$refs.data5.columns[i].label)
          }
        }

        for (const item of this.data5) {
          const row = [item.label]
          for (const month of this.c__get_list_month) {
            for (const day of this.m__get_around_flash_sale(month.value)) {
              row.push(this.m__get_data5_by_month_and_day(item, month.key, day))
            }
          }
          data.push(row)
        }

        const filename = `report_${this.shop.username}_${this.dayjs().format('DDMMYYYY')}.xlsx`
        const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/export_excel', {
          filename,
          data: [row1, row2, ...data]
        }, {
          ...this.cf(),
          responseType: 'blob'
        })
        const url = window.URL.createObjectURL(new Blob([response.body]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
      }
    },

    m__get_nested_object(obj, path) {
      return path.split('.').reduce((o, key) => (o && typeof o === 'object') ? o[key] : undefined, obj)
    },

    m__get_data5_by_month_and_day(data, month, day) {
      if (data[`t_${month}`]) {
        const found = data[`t_${month}`].find(i => i.label === day)
        return found ? (data.is_percent ? `${found.value}%` : this.format_currency_with_decimal(+found.value)) : 0
      }

      return 0
    },

    m__get_around_flash_sale(month) {
      const flash_sale = this.spike_days.find(i => i.month === month && i.type === 'spike_day')
      if (flash_sale) {
        return [
          `${flash_sale.day - 1}/${month}`,
          `${flash_sale.day}/${month}`,
          `${flash_sale.day + 1}/${month}`,
        ]
      }

      return []
    },

    async m__get_spike_days() {
      const resp = await this.$http.get(this.API.URL_API_SRV_2 + '/shopee/spike_days', this.cf())
      this.spike_days = resp.body.data
    },

    m__sort_change({
                     prop,
                     order
                   }) {
      this.product_sort_option.order = order
      this.product_sort_option.prop = prop
    },

    async m__initial_view() {
      const items = this.shopee_shop.list.filter(e => e._id === this.shopee_shop.selected)

      try {
        if (this.shopee_shop.selected.length > 6) {
          if (items.length > 0) {
            const shop = items[0]

            if (!this.check_role(shop, 'marketing', 'monthly_report')) {
              this.shopee_shop.selected = ''
              return
            }

            this.shop = shop
            this.seller = await this.init_seller(shop)

            if (!await this.check_shop(this.seller)) {
              this.shopee_shop.selected = ''
              return
            }

            this.ntf_s(`${this.$t('shop.connected_to')}: ${this.shop.username}`)
          }
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(`${this.$t('shop.connect_shop_error')}: ${this.shop.username}`)
      } finally {
      }
    },

    async m__update_data() {
      if (!this.date_range || !this.date_range[0] || !this.date_range[1]) {
        this.ntf_w(this.$t('required.select_duration'))
        return
      }

      this.data1 = []
      this.data2 = []
      this.data3 = []
      this.data4 = []
      this.data5 = []

      this.loading.get_data = true

      let start_month = this.dayjs(this.date_range[0]).startOf('month')
      let end_month = this.dayjs(this.date_range[1]).endOf('month')

      while (start_month.isSameOrBefore(end_month, 'month')) {
        try {
          console.log(start_month.format('MM-YYYY'))

          const start_time = start_month.clone().startOf('month')
          const end_time = start_month.clone().endOf('month').isAfter(this.dayjs())
            ? this.dayjs()
            : start_month.clone().endOf('month')

          // todo: get data 1
          const data1 = {
            label: `Tháng ${start_month.month() + 1}/${start_month.year()}`,
            gmv: 0,
            order: 0,
            aov: 0,
            gmv_ads: 0,
            cost_ads: 0,
            order_ads: 0,
            aov_ads: 0,
            view_ads: 0,
            click_ads: 0,
            cr: 0,
            ctr: 0,
            cir: 0,
            roas: 0,
            gmv_voucher: 0,
            cost_voucher: 0,
            detail: []
          }
          const s1 = start_time.unix()
          const s2 = start_month.isSame(this.dayjs(), 'month')
            ? this.dayjs().startOf('d').unix()
            : end_time.clone().add(1, 'day').startOf('day').unix()
          const key_metrics_response = await this.seller.dashboard__key_metrics(s1, s2, 'month')
          console.log('key_metrics_response', key_metrics_response)
          if (key_metrics_response && key_metrics_response.result) {
            data1.gmv = this.m__calculate(key_metrics_response.result.confirmed_gmv.value)
            data1.order = Number(key_metrics_response.result.confirmed_orders.value)
          }

          const voucher_key_metrics_response = await this.seller.voucher__key_metrics(s1, s2, 'month')
          console.log('voucher_key_metrics_response', voucher_key_metrics_response)
          if (voucher_key_metrics_response && voucher_key_metrics_response.result) {
            data1.gmv_voucher = this.m__calculate(voucher_key_metrics_response.result.sales.value)
            data1.cost_voucher = this.m__calculate(voucher_key_metrics_response.result.cost.value)
            data1.voucher_usage = Number(voucher_key_metrics_response.result.orders.value)
          }

          let report_response;
          if (!report_response) {
            try {
              const cache_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/shopee_ads/get_ads_metrics_month', {
                shop_id: this.shop._id,
                month: start_time.month(),
                year: start_time.year()
              }, this.cf())
              if (cache_response && cache_response.body && cache_response.body.data && cache_response.body.data.report_aggregate) {
                report_response = {
                  data: {
                    report_aggregate: cache_response.body.data.report_aggregate,
                    report_by_time: cache_response.body.data.report_by_time
                  }
                }
              }
            } catch (e) {
              console.error(e)
            }
          }
          if (!report_response) {
            report_response = await this.seller.marketing_get_time_graph_by_month('new_cpc_homepage', start_time.unix(), end_time.endOf('day').unix(), {})
          }
          if (report_response && report_response.data) {
            data1.gmv_ads = this.m__calculate(report_response.data.report_aggregate.broad_gmv / 100000)
            data1.cost_ads = this.m__calculate(report_response.data.report_aggregate.cost / 100000)
            data1.order_ads = Math.round(report_response.data.report_aggregate.broad_order)
            data1.view_ads = Math.round(report_response.data.report_aggregate.impression)
            data1.click_ads = Math.round(report_response.data.report_aggregate.click)
            data1.cr = +(report_response.data.report_aggregate.cr * 100).toFixed(2)
            data1.ctr = +(report_response.data.report_aggregate.ctr * 100).toFixed(2)
            data1.cir = +(report_response.data.report_aggregate.broad_cir * 100).toFixed(2)
            data1.roas = +(report_response.data.report_aggregate.broad_roi).toFixed(2)
          }

          if (data1.order) data1.aov = this.m__calculate(data1.gmv / data1.order)
          if (data1.order_ads) data1.aov_ads = this.m__calculate(data1.gmv_ads / data1.order_ads)

          const day_number = start_month.endOf('month').date()
          for (let i = 1; i <= day_number; i++) {
            const data_detail = {
              label: `${i}/${start_month.month() + 1}/${start_month.year()}`,
              gmv: 0,
              order: 0,
              aov: 0,
              gmv_ads: 0,
              cost_ads: 0,
              order_ads: 0,
              aov_ads: 0,
              view_ads: 0,
              click_ads: 0,
              cr: 0,
              ctr: 0,
              cir: 0,
              roas: 0,
              gmv_voucher: 0,
              cost_voucher: 0
            }

            if (start_month.date(i).isBefore(this.dayjs(), 'day')) {
              data_detail.gmv = key_metrics_response.result.confirmed_gmv.points.find(ii => this.dayjs(ii.timestamp * 1000).date() === i).value
              data_detail.order = key_metrics_response.result.confirmed_orders.points.find(ii => this.dayjs(ii.timestamp * 1000).date() === i).value

              data_detail.gmv_voucher = voucher_key_metrics_response.result.sales.points.find(ii => this.dayjs(ii.timestamp * 1000).date() === i).value
              data_detail.cost_voucher = voucher_key_metrics_response.result.cost.points.find(ii => this.dayjs(ii.timestamp * 1000).date() === i).value
              data_detail.voucher_usage = voucher_key_metrics_response.result.cost.points.find(ii => this.dayjs(ii.timestamp * 1000).date() === i).value

              if (report_response && report_response.data && report_response.data.report_by_time) {
                const ads_metrics = report_response.data.report_by_time.find(ii => this.dayjs(+ii.key * 1000).date() === i).metrics
                data_detail.gmv_ads = this.m__calculate(ads_metrics.broad_gmv / 100000)
                data_detail.cost_ads = this.m__calculate(ads_metrics.cost / 100000)
                data_detail.order_ads = Math.round(ads_metrics.broad_order)
                data_detail.view_ads = Math.round(ads_metrics.impression)
                data_detail.click_ads = Math.round(ads_metrics.click)
                data_detail.cr = +(ads_metrics.cr * 100).toFixed(2)
                data_detail.ctr = +(ads_metrics.ctr * 100).toFixed(2)
                data_detail.cir = +(ads_metrics.broad_cir * 100).toFixed(2)
                data_detail.roas = +(ads_metrics.broad_roi).toFixed(2)
              }

              if (data_detail.order) data_detail.aov = this.m__calculate(data_detail.gmv / data_detail.order)
              if (data_detail.order_ads) data_detail.aov_ads = this.m__calculate(data_detail.gmv_ads / data_detail.order_ads)
            }

            data1.detail.push(data_detail)
          }

          this.data1.push(data1)

          // todo: get data 2
          const data2 = {
            label: `Tháng ${start_month.month() + 1}/${start_month.year()}`,
            uv: 0,
            pv: 0,
            uv_x_pv: 0,

            atc_uv: 0,
            atc_uv_x_uv: 0,

            placed_buyers: 0,
            placed_buyers_x_atc_uv: 0,

            confirmed_buyers: 0,
            confirmed_buyers_x_placed_buyers: 0,

            atc_unit_num: 0,
            atc_unit_num_x_atc_uv: 0,

            placed_unit_num: 0,
            placed_unit_num_x_atc_unit_num: 0
          }
          const get_product_over_view_response = await this.seller.get_product_over_view(s1, s2, 'month')
          console.log(get_product_over_view_response)
          if (get_product_over_view_response && get_product_over_view_response.uv) {
            data2.uv = Number(get_product_over_view_response.uv.value)
            data2.pv = Number(get_product_over_view_response.pv.value)
            data2.atc_uv = Number(get_product_over_view_response.atc_uv.value)
            data2.placed_buyers = Number(get_product_over_view_response.placed_buyers.value)
            data2.confirmed_buyers = Number(get_product_over_view_response.confirmed_buyers.value)
            data2.atc_unit_num = Number(get_product_over_view_response.atc_unit_num.value)
            data2.placed_unit_num = Number(get_product_over_view_response.placed_unit_num.value)

            data2.uv_x_pv = data2.pv ? +(data2.uv / data2.pv * 100).toFixed(2) : 0
            data2.atc_uv_x_uv = data2.uv ? +(data2.atc_uv / data2.uv * 100).toFixed(2) : 0
            data2.placed_buyers_x_atc_uv = data2.atc_uv ? +(data2.placed_buyers / data2.atc_uv * 100).toFixed(2) : 0
            data2.confirmed_buyers_x_placed_buyers = data2.placed_buyers ? +(data2.confirmed_buyers / data2.placed_buyers * 100).toFixed(2) : 0
            data2.atc_unit_num_x_atc_uv = data2.atc_uv ? +(data2.atc_unit_num / data2.atc_uv).toFixed(2) : 0
            data2.placed_unit_num_x_atc_unit_num = data2.atc_unit_num ? +(data2.placed_unit_num / data2.atc_unit_num * 100).toFixed(2) : 0
          }
          this.data2.push(data2)

          // todo: get data 4
          const flash_sale = this.spike_days.find(i => i.month === start_month.month() + 1 && i.type === 'spike_day')
          if (flash_sale) {
            console.log('flash_sale', flash_sale)
            if (!this.data4.length) {
              for (let i = flash_sale.day - 1; i <= flash_sale.day + 1; i++) {
                const row = {
                  label: '',
                  type: ''
                }

                if (i < flash_sale.day) {
                  row.label = this.$t('day.before_flash_sale')
                  row.type = 'before'
                }
                if (i === flash_sale.day) {
                  row.label = this.$t('day.flash_sale')
                  row.type = 'current'
                }
                if (i > flash_sale.day) {
                  row.label = this.$t('day.after_flash_sale')
                  row.type = 'after'
                }
                this.data4.push(row)
              }
            }
            for (const item of this.data4) {
              const data = {
                gmv: 0,
                order: 0,
                aov: 0,
                gmv_ads: 0,
                cost_ads: 0,
                order_ads: 0,
                aov_ads: 0,
                view_ads: 0,
                click_ads: 0,
                cr: 0,
                ctr: 0,
                cir: 0,
                roas: 0
              }

              let start_unix
              let end_unix
              if (item.type === 'before') {
                start_unix = start_month.clone().date(flash_sale.day - 1).startOf('day').unix()
                end_unix = start_month.clone().date(flash_sale.day - 1).endOf('day').unix()
              }
              if (item.type === 'current') {
                start_unix = start_month.clone().date(flash_sale.day).startOf('day').unix()
                end_unix = start_month.clone().date(flash_sale.day).endOf('day').unix()
              }
              if (item.type === 'after') {
                start_unix = start_month.clone().date(flash_sale.day + 1).startOf('day').unix()
                end_unix = start_month.clone().date(flash_sale.day + 1).endOf('day').unix()
              }
              console.log('start_unix', start_unix)
              console.log('end_unix', end_unix)

              const gmv = key_metrics_response.result.confirmed_gmv.points.reduce((t, i) => {
                if (i.timestamp >= start_unix && i.timestamp <= end_unix) {
                  t += +i.value
                }
                return t
              }, 0)
              const order = key_metrics_response.result.confirmed_orders.points.reduce((t, i) => {
                if (i.timestamp >= start_unix && i.timestamp <= end_unix) {
                  t += +i.value
                }
                return t
              }, 0)

              const [gmv_ads, cost_ads, order_ads, view_ads, click_ads] = report_response.data
                ? report_response.data.report_by_time.reduce((r, i) => {
                  if (+i.key >= start_unix && +i.key <= end_unix) {
                    r[0] += this.m__calculate(+i.metrics.broad_gmv / 100000)
                    r[1] += this.m__calculate(+i.metrics.cost / 100000)
                    r[2] += +i.metrics.broad_order
                    r[3] += +i.metrics.impression
                    r[4] += +i.metrics.click
                  }
                  return r
                }, [0, 0, 0, 0, 0])
                : [0, 0, 0, 0, 0]

              data.gmv = gmv
              data.order = order
              data.aov = order ? this.m__calculate(gmv / order) : 0

              data.gmv_ads = gmv_ads
              data.cost_ads = cost_ads
              data.order_ads = order_ads
              data.view_ads = view_ads
              data.click_ads = click_ads
              data.cr = click_ads ? parseFloat((order_ads / click_ads * 100).toFixed(2)) : 0
              data.ctr = view_ads ? parseFloat((click_ads / view_ads * 100).toFixed(2)) : 0
              data.cir = gmv_ads ? parseFloat((cost_ads / gmv_ads * 100).toFixed(2)) : 0
              data.roas = cost_ads ? parseFloat((gmv_ads / cost_ads).toFixed(2)) : 0
              data.aov_ads = order_ads ? this.m__calculate(gmv_ads / order_ads) : 0

              item[`t_${start_time.format('MMYYYY')}`] = data
            }

            // todo: get data5
            if (!this.data5.length) {
              this.data5.push({
                label: 'GMV',
                key: 'gmv'
              })
              this.data5.push({
                label: this.$t('metric.orders'),
                key: 'order'
              })
              this.data5.push({
                label: 'AOV',
                key: 'aov'
              })
              this.data5.push({
                label: 'GMV Ads',
                key: 'gmv_ads'
              })
              this.data5.push({
                label: this.$t('metric.ads_expense'),
                key: 'cost_ads'
              })
              this.data5.push({
                label: this.$t('metric.ads_orders'),
                key: 'order_ads'
              })
              this.data5.push({
                label: 'AOV Ads',
                key: 'aov_ads'
              })
              this.data5.push({
                label: 'View Ads',
                key: 'view_ads'
              })
              this.data5.push({
                label: 'Click Ads',
                key: 'click_ads'
              })
              this.data5.push({
                label: 'CTR',
                key: 'ctr',
                is_percent: true
              })
              this.data5.push({
                label: 'CR',
                key: 'cr',
                is_percent: true
              })
              this.data5.push({
                label: 'CIR',
                key: 'cir',
                is_percent: true
              })
              this.data5.push({
                label: 'ROAS',
                key: 'roas'
              })
              this.data5.push({
                label: 'GMV voucher',
                key: 'gmv_voucher'
              })
              this.data5.push({
                label: this.$t('metric.voucher_expense'),
                key: 'cost_voucher'
              })
              this.data5.push({
                label: this.$t('metric.voucher_usage'),
                key: 'voucher_usage'
              })
            }
            for (const item of this.data5) {
              item[`t_${start_time.format('MMYYYY')}`] = []

              for (let i = flash_sale.day - 1; i <= flash_sale.day + 1; i++) {
                const start_unix = start_month.clone().date(i).startOf('day').unix()
                const end_unix = start_month.clone().date(i).endOf('day').unix()
                console.log('start_unix', start_unix)
                console.log('end_unix', end_unix)

                const gmv = key_metrics_response.result.confirmed_gmv.points.reduce((t, i) => {
                  if (i.timestamp >= start_unix && i.timestamp <= end_unix) {
                    t += +i.value
                  }
                  return t
                }, 0)

                const order = key_metrics_response.result.confirmed_orders.points.reduce((t, i) => {
                  if (i.timestamp >= start_unix && i.timestamp <= end_unix) {
                    t += +i.value
                  }
                  return t
                }, 0)


                const gmv_voucher = voucher_key_metrics_response.result.sales.points.reduce((t, i) => {
                  if (i.timestamp >= start_unix && i.timestamp <= end_unix) {
                    t += +i.value
                  }
                  return t
                }, 0)

                const cost_voucher = voucher_key_metrics_response.result.cost.points.reduce((t, i) => {
                  if (i.timestamp >= start_unix && i.timestamp <= end_unix) {
                    t += +i.value
                  }
                  return t
                }, 0)

                const voucher_usage = voucher_key_metrics_response.result.orders.points.reduce((t, i) => {
                  if (i.timestamp >= start_unix && i.timestamp <= end_unix) {
                    t += +i.value
                  }
                  return t
                }, 0)

                const [gmv_ads, cost_ads, order_ads, view_ads, click_ads] = report_response.data
                  ? report_response.data.report_by_time.reduce((r, i) => {
                    if (+i.key >= start_unix && +i.key <= end_unix) {
                      r[0] += this.m__calculate(+i.metrics.broad_gmv / 100000)
                      r[1] += this.m__calculate(+i.metrics.cost / 100000)
                      r[2] += +i.metrics.broad_order
                      r[3] += +i.metrics.impression
                      r[4] += +i.metrics.click
                    }
                    return r
                  }, [0, 0, 0, 0, 0])
                  : [0, 0, 0, 0, 0]

                const data = {}
                data.gmv = this.m__calculate(gmv)
                data.order = Math.round(order)
                data.aov = order ? this.m__calculate(gmv / order) : 0

                data.gmv_ads = gmv_ads
                data.cost_ads = cost_ads
                data.order_ads = Math.round(order_ads)
                data.view_ads = Math.round(view_ads)
                data.click_ads = Math.round(click_ads)
                data.cr = click_ads ? parseFloat((order_ads / click_ads * 100).toFixed(2)) : 0
                data.ctr = view_ads ? parseFloat((click_ads / view_ads * 100).toFixed(2)) : 0
                data.cir = gmv_ads ? parseFloat((cost_ads / gmv_ads * 100).toFixed(2)) : 0
                data.roas = cost_ads ? parseFloat((gmv_ads / cost_ads).toFixed(2)) : 0
                data.aov_ads = order_ads ? this.m__calculate(gmv_ads / order_ads) : 0
                data.gmv_voucher = this.m__calculate(gmv_voucher)
                data.cost_voucher = this.m__calculate(cost_voucher)
                data.voucher_usage = Math.round(voucher_usage)

                item[`t_${start_time.format('MMYYYY')}`].push({
                  label: `${i}/${start_month.month() + 1}`,
                  value: data[item.key]
                })
              }
            }
          }
          this.data4 = this.clone(this.data4)
          console.log('data4', this.data4)

          // todo: get data 5
          this.data5 = this.clone(this.data5)
          console.log('data5', this.data5)

          // todo: get data 3
          const canceled_products_response = await this.$http.post(this.API.URL_API_SRV_2 + '/shopee/canceled_products', {
            shop_id: this.shop.shop_id,
            start_time: start_time.unix(),
            end_time: end_time.unix()
          }, this.cf())
          console.log(canceled_products_response)
          const canceled_products_data = canceled_products_response.body && canceled_products_response.body.data
            ? canceled_products_response.body.data
            : {}

          const cache_product_performance_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/shopee_ads/get_product_performance_month', {
            shop_id: this.shop._id,
            month: start_time.month(),
            year: start_time.year(),
          }, this.cf())
          const product_performance = []
          if (cache_product_performance_response && cache_product_performance_response.body && cache_product_performance_response.body.data) {
            let data = typeof cache_product_performance_response.body.data === 'string'
              ? JSON.parse(cache_product_performance_response.body.data)
              : cache_product_performance_response.body.data
            product_performance.push(...data)
          } else {
            let page = 1, page_size = 20, has_error = false
            let product_performance_resp = await this.seller.get_product_performance_main(page, page_size, s1, s2, 'month')
            if (!product_performance_resp || !product_performance_resp.data || !product_performance_resp.data.result) {
              has_error = true
            }
            while (product_performance_resp && product_performance_resp.data && product_performance_resp.data.result && product_performance_resp.data.result.items && product_performance_resp.data.result.items.length) {
              product_performance.push(...product_performance_resp.data.result.items)
              page++
              product_performance_resp = await this.seller.get_product_performance_main(page, page_size, s1, s2, 'month')
              if (!product_performance_resp || !product_performance_resp.data || !product_performance_resp.data.result) {
                has_error = true
              }
            }

            if (!has_error && start_time.isBefore(this.dayjs(), 'month')) {
              this.$http.post(this.API.URL_API_SRV_2 + '/mipee/shopee_ads/save_product_performance_month', {
                shop_id: this.shop._id,
                month: start_time.month(),
                year: start_time.year(),
                data: JSON.stringify(product_performance)
              }, this.cf()).catch(console.error)
            }
          }


          for (const item of product_performance) {
            const found = this.data3.find(i => i.itemid === item.id)
            if (found) {
              found[`t_${start_time.format('MMYYYY')}`] = {
                add_to_cart_units: item.add_to_cart_units,
                pv: item.pv,
                add_to_cart_units_x_pv: +item.pv ? +(+item.add_to_cart_units / +item.pv * 100).toFixed(2) : 0,

                confirmed_units: item.confirmed_units,
                confirmed_units_x_add_to_cart_units: +item.add_to_cart_units ? (+item.confirmed_units / +item.add_to_cart_units * 100).toFixed(2) : 0,

                confirmed_sales: this.m__calculate(item.confirmed_sales),

                // placed: item.placed_order_per_buyers,
                // placed_sales: item.placed_sales,

                placed: canceled_products_data[item.id] ? canceled_products_data[item.id].placed : 0,
                placed_sales: canceled_products_data[item.id] ? canceled_products_data[item.id].placed_sales : 0,
                canceled: canceled_products_data[item.id] ? canceled_products_data[item.id].canceled : 0,
                canceled_sales: canceled_products_data[item.id] ? canceled_products_data[item.id].canceled_sales : 0,
                to_return: canceled_products_data[item.id] ? canceled_products_data[item.id].to_return : 0,
                to_return_sales: canceled_products_data[item.id] ? canceled_products_data[item.id].to_return_sales : 0,
              }
            } else {
              const row = {
                itemid: item.id,
                name: item.name,
                image: item.image
              }
              row[`t_${start_time.format('MMYYYY')}`] = {
                add_to_cart_units: item.add_to_cart_units,
                pv: item.pv,
                add_to_cart_units_x_pv: +item.pv ? +(+item.add_to_cart_units / +item.pv * 100).toFixed(2) : 0,

                confirmed_units: item.confirmed_units,
                confirmed_units_x_add_to_cart_units: +item.add_to_cart_units ? +(+item.confirmed_units / +item.add_to_cart_units * 100).toFixed(2) : 0,

                confirmed_sales: this.m__calculate(item.confirmed_sales),

                // placed: item.placed_order_per_buyers,
                // placed_sales: item.placed_sales,

                placed: canceled_products_data[item.id] ? canceled_products_data[item.id].placed : 0,
                placed_sales: canceled_products_data[item.id] ? canceled_products_data[item.id].placed_sales : 0,
                canceled: canceled_products_data[item.id] ? canceled_products_data[item.id].canceled : 0,
                canceled_sales: canceled_products_data[item.id] ? canceled_products_data[item.id].canceled_sales : 0,
                to_return: canceled_products_data[item.id] ? canceled_products_data[item.id].to_return : 0,
                to_return_sales: canceled_products_data[item.id] ? canceled_products_data[item.id].to_return_sales : 0,
              }
              this.data3.push(row)
            }
          }
          this.data3 = this.clone(this.data3)
          console.log(this.data3)
        } catch (e) {
          console.error(e)
        }

        start_month = start_month.add(1, 'month')
      }

      // fix missing data3 data
      start_month = this.dayjs(this.date_range[0]).startOf('month')
      end_month = this.dayjs(this.date_range[1]).endOf('month')
      while (start_month.isSameOrBefore(end_month, 'month')) {
        for (const row of this.data3) {
          if (!row[`t_${start_month.format('MMYYYY')}`]) {
            row[`t_${start_month.format('MMYYYY')}`] = {
              add_to_cart_units: 0,
              pv: 0,
              add_to_cart_units_x_pv: 0,
              confirmed_units: 0,
              confirmed_units_x_add_to_cart_units: 0,
              confirmed_sales: 0
            }
          }
        }
        start_month = start_month.add(1, 'month')
      }
      this.data3 = this.clone(this.data3)
      console.log(this.data3)

      this.loading.get_data = false
    },

    m__get_data3_by_month(data, key, sub_key) {
      if (data['t_' + key] && data['t_' + key][sub_key]) {
        return data['t_' + key][sub_key]
      } else {
        return 0
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/center/monthly_report.vue